(function() {
    $(document).ready(function() {
        $("body").addClass("swell-rewards-page");
        $(document).on("swell:setup", function() {
            Swell.Campaign.initializeCampaigns(".swell-campaign-list", SwellConfig.Campaign.opts);
            SwellConfig.Campaign.authenticate();
            SwellConfig.Campaign.removeBirthdayCampaigns();
            SwellConfig.Referral.initializeReferral(".swell-referral");      
            SwellConfig.Referral.populateReferrals();
            $(".swell-referral-rewards .swell-referral-details").html("Give your friends 20% off on their first online order and get  a $20 online credit for each successful referral.");
            $(".swell-post-checkout").css("display", "flex");
            Swell.Redemption.initializeProductRedemptions(".swell-redemption-list", SwellConfig.Redemption.opts);
            SwellConfig.Redemption.initializeProducts();
            SwellConfig.Redemption.initializeSlider();
            SwellConfig.Tier.initializeDummyTier();
            SwellConfig.Tier.initializeCustomTierProperties();
            SwellConfig.Tier.initializeTiers(".swell-tier-table-desktop");
            $(".swell-post-checkout .swell-referral-back-link").click(function() {
                $(".swell-post-checkout").hide();
            });
            $(".swell-loader-holder").hide();
            $(document).on("swell:referral:success", function() {
                swellAPI.refreshCustomerDetails(function() {
                    $(".table-data").html("");
                    SwellConfig.Referral.populateReferrals();
                });
            });
        });

        $(document).on("swell:referral:error", function(jqXHR, textStatus, errorThrown) {
            if (textStatus && textStatus === "EMAILS_ALREADY_PURCHASED") {
                $(".refer-customer-error").remove();
                $(".swell-referral-form-list").before('<p class="refer-customer-error">Sorry! Looks like this person has already made a purchase. Try referring another friend.</p>');
            }

            if (textStatus && textStatus === "Please enter a valid email address") {
                $(".refer-customer-error").remove();
                $(".swell-referral-form-list").before('<p class="refer-customer-error">Please enter valid email addresses seperated with commas</p>');
            }
        });

        $(document).on("click", ".swell-tier-arrows .swell-icon-right-tier", function() {
            var last = false;
            var length = $(".swell-tier-table thead .swell-tier-names th").length;
            var starting_index = 2;

            for (counter = starting_index; counter <= length; counter++) {
                if (!$(".swell-tier-table thead tr th:nth-child(" + counter + ")").hasClass("hidden")) {
                    if (counter == length) {
                        last = true;
                    }
                    break;
                }
            }

            if (last == true) {
                $(".swell-tier-table  tr th:nth-child(" + counter + ")").addClass("hidden");
                $(".swell-tier-table  tr th:nth-child(" + (counter - 3) + ")").removeClass("hidden");

                $(".swell-tier-table  tr td:nth-child(" + counter + ")").addClass("hidden");
                $(".swell-tier-table  tr td:nth-child(" + (counter - 3) + ")").removeClass("hidden");
            } else {
                $(".swell-tier-table  tr th:nth-child(" + counter + ")").addClass("hidden");
                $(".swell-tier-table  tr th:nth-child(" + (counter + 1) + ")").removeClass("hidden");

                $(".swell-tier-table  tr td:nth-child(" + counter + ")").addClass("hidden");
                $(".swell-tier-table  tr td:nth-child(" + (counter + 1) + ")").removeClass("hidden");
            }
        });

        $(document).on("click", ".swell-tier-arrows .swell-icon-left-tier", function() {
            var first = false;
            var length = $(".swell-tier-table thead .swell-tier-names th").length;
            var starting_index = 2;

            for (counter = starting_index; counter <= length; counter++) {
                if (!$(".swell-tier-table thead tr th:nth-child(" + counter + ")").hasClass("hidden")) {
                    if (counter == starting_index) {
                        first = true;
                    }
                    break;
                }
            }

            if (first == true) {
                $(".swell-tier-table  tr th:nth-child(" + counter + ")").addClass("hidden");
                $(".swell-tier-table  tr th:nth-child(" + (counter + 3) + ")").removeClass("hidden");

                $(".swell-tier-table  tr td:nth-child(" + counter + ")").addClass("hidden");
                $(".swell-tier-table  tr td:nth-child(" + (counter + 3) + ")").removeClass("hidden");
            } else {
                $(".swell-tier-table thead tr th:nth-child(" + counter + ")").addClass("hidden");
                $(".swell-tier-table thead tr th:nth-child(" + (counter - 1) + ")").removeClass("hidden");

                $(".swell-tier-table tbody tr td:nth-child(" + counter + ")").addClass("hidden");
                $(".swell-tier-table tbody tr td:nth-child(" + (counter - 1) + ")").removeClass("hidden");
            }
        });

        $(document).on('click', '.swell-post-checkout .checkout-heading .swell-referral-back-link', function(e) {
            $(".swell-post-checkout").hide();
        });

        $(document).on('click', '.swell-post-checkout .swell-referral-section > .swell-referral-back-link', function(e) {
            $(".swell-post-checkout").hide();
        });

        $('body').on('click', '.swell-referral-copy', function(e) {
            if ($(e.target).hasClass("swell-referral-copy")) {
                e.stopPropagation();
            }
        });
    });

}).call(this);

(function() {
    window.SwellConfig = window.SwellConfig || {};

    SwellConfig.Campaign = {
        opts: {
            templates: {
                campaign: "<li class='swell-campaign'> <div class='swell-campaign-content' data-display-mode='modal' data-campaign-id='<%= campaign.id %>'> <div class='swell-campaign-holder'> <div class='swell-campaign-icon'> <span class='swell-campaign-icon-content'><i class='swell-icon <%= campaign.icon %>'></i></span> </div> <div class='swell-campaign-type'> <span class='swell-campaign-type-content'><%= campaign.title %></span> </div> </div> <div class='swell-campaign-value'> <span class='swell-campaign-value-content'><%= campaign.reward_text %></span> </div> </div> </li>"
            }
        },
        authenticate: function() {
            if (spapi.authenticated) {
                $(".swell-campaign").css("cursor", "pointer");
            }
        },
        removeBirthdayCampaigns() {
          if(!spapi.authenticated) {
            $(".swell-campaign .swell-campaign-content[data-campaign-id='489714']").parent().remove();
            $(".swell-campaign .swell-campaign-content[data-campaign-id='489715']").parent().remove();
          }
        }
    };

}).call(this);

(function() {
    window.SwellConfig = window.SwellConfig || {};

    SwellConfig.Referral = {
        opts: {
            localization: {
                referralRegisterHeading: "Give <%= referralCampaign.reward_text %>%, Get $<%= referralCampaign.reward_text %>",
                referralRegisterFormDetails: "Enter your email below to get started.",
                referralReferHeading: "Give <%= referralCampaign.reward_text %>%, Get $<%= referralCampaign.reward_text %>",
                referralThanksHeading: "Thanks for Referring.",
                referralReferMediaDetails: "You can also share your link with the buttons below.",
                referralReferFormDetails: "Now, Enter your friends’ emails.",
                referralReferFormEmailsDetails: "",
                referralRegisterFormEmail: "Enter email here...",
                referralReferFormEmails: "Your friends’ emails (separated by commas)",
                referralRegisterFormEmail: "your email",
                referralRegisterFormSubmit: "Next",
                referralReferFormSubmit: "Send",
                referralCopyButton: "COPY LINK",
                referralCopyDetails: "Copy link and share with your friends."
            },
            templates: {
                referralRegister: '<div class="swell-referral-register"> <span class="swell-referral-heading-refer">Refer a Friend</span> <h2 class="swell-referral-heading"><%= localization.referralRegisterHeading %></h2> <p class="swell-referral-details"><%= localization.referralRegisterDetails %></p> <div class="swell-referral-form-wrapper"> <form class="swell-referral-form" name="swell-referral-register-form" id="swell-referral-register-form" method="POST" action="."> <div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="email" name="swell-referral-register-email" id="swell-referral-register-email" swellrequired="swellrequired" placeholder="<%= localization.referralRegisterFormEmail %>"> <input class="swell-referral-form-list-submit" type="submit" name="swell-referral-register-submit" id="swell-referral-register-submit" value="<%= localization.referralRegisterFormSubmit %>"> </li> </ul> </div> </form> </div> </div>',
                referralRefer: '<div class="swell-referral-refer"><span class="swell-referral-heading-refer">Refer a Friend</span><h2 class="swell-referral-heading"><%= localization.referralReferHeading %></h2> <p class="swell-referral-details"><%= localization.referralReferDetails %></p><div class="swell-referral-form-wrapper"> <form class="swell-referral-form" name="swell-referral-refer-form" id="swell-referral-refer-form" method="POST" action="."> <div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="text" name="swell-referral-refer-emails" id="swell-referral-refer-emails" swellrequired="swellrequired" placeholder="<%= localization.referralReferFormEmails %>"> <input class="swell-referral-form-list-submit" type="submit" name="swell-referral-refer-submit" id="swell-referral-refer-submit" value="<%= localization.referralReferFormSubmit %>"> </li></ul> </div> </form> </div> <div class="swell-referral-media-wrapper"> <p class="swell-referral-media-details"><%= localization.referralReferMediaDetails %></p> <ul class="swell-referral-media-list"> <li class="swell-referral-medium swell-share-referral-facebook"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon swell-icon-fb1" aria-hidden="true"></i>Share </div> </li>  <li class="swell-referral-medium swell-share-referral-twitter"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon swell-icon-tweet-1" aria-hidden="true"></i>&nbsp;Tweet</div> </li>  <li class="swell-referral-medium swell-share-referral-messenger"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon swell-icon-message" aria-hidden="true"></i>Message </div> </li> <li class="swell-referral-medium swell-mobile swell-share-referral-sms"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon swell-icon-sms" aria-hidden="true"></i>SMS </div> </li> <li class="swell-referral-medium swell-share-referral-copy"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon swell-icon-copy-link-2" aria-hidden="true"></i>Copy Link </div> </li> </ul> </div> </div>'
            }
        },
        initializeReferral: function(containerSelector) {
          var email = $(containerSelector).data("customer-email");
          if (email) {
            spapi.storage.setItem("referrer_email", email);
            spapi.customer.email = email;
          }
          Swell.Referral.initializeReferral(".swell-referral", SwellConfig.Referral.opts);
        },
        populateReferrals: function() {
            if (spapi.authenticated) {
                var referral_receipts = spapi.customer.referral_receipts;
                referral_receipts.forEach(function(referral_receipt) {
                    var email = referral_receipt.email;
                    var completed_at = referral_receipt.completed_at;
                    if (completed_at) {
                        status = "purchased (" + spapi.activeReferralCampaign.reward_text + "earned)";
                    } else {
                        status = "invited";
                    }
                    $(".table-data").append("<tr class='swell-table-row'><td class='swell-td swell-truncate'>" + email + "</td><td class='swell-td'>" + status + "</td></tr>");
                });
            }
        }
    };
}).call(this);

// redemption
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Redemption = {
    opts: {
      templates: {
        redemptionOptionProduct: '<div class="swell-redemption"> <img src="<%= redemption.background_image_url %>" }}"> <div class="swell-redeem-content"> <p class="product-name"> <%= redemption.name %> </p><p class="swell-price"> <%= redemption.amount %> Points </p> <a class="swell-redeem-btn swell-buy-product-btn" data-variant-id="<%= redemption.applies_to_id %>" data-hide-logged-out="true|false" data-confirm-title="Are you sure?" data-confirm-content="You currently have *|point_balance|* points available. This product costs *|amount|* points to redeem." data-confirm-btn-text="Yes, buy it" data-error-type="red" data-error-title="Whoops!" data-error-content="Looks like you don\'t have enough points for this product. This product costs *|amount|* points and you only have *|point_balance|* points available." data-error-okay-text="Ok" data-success-type="green" data-success-title="Success!" data-success-content="Product was successfully added to your cart" data-success-ok-btn="Keep Shopping" data-success-cart-btn="View Cart" data-success-cart-link="/cart">Redeem Now</a> </div> </div>'
      }
    },
    initializeSlider: function() {
        $('.swell-redemption-list').slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 3,
            arrows: true,
            nextArrow: '<i class="swell-icon-swell-right-arrow"><span class="path1"></span><span class="path2"></span></i>',
            prevArrow: '<i class="swell-icon-swell-left-arrow"><span class="path1"></span><span class="path2"></span></i>',
            responsive: [
            {
                breakpoint: 769,
                settings: {
                 slidesToScroll: 1,
                 slidesToShow: 1
                },
            }]
        });
    },
    initializeProducts: function() {
      if(spapi.authenticated) {
        spapi.setupBuyProductWithPointsHelper();
      }
    }
  };
}).call(this);

(function() {
    window.SwellConfig = window.SwellConfig || {};

    SwellConfig.Tier = {
        getCustomerTierId: function() {
            var customer_tier, intro_tier, tiers;
            customer_tier = spapi.customer.vip_tier;
            tiers = spapi.activeVipTiers;
            if (customer_tier) {
                return customer_tier.id;
            } else {
                intro_tier = $.grep(tiers, function(e) {
                    return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
                });
                if (intro_tier.length > 0) {
                    return intro_tier[0].id;
                } else {
                    return null;
                }
            }
        },
        getCustomerTierRank: function() {
            var customer_tier, intro_tier, rank, tiers;
            customer_tier = spapi.customer.vip_tier;
            tiers = spapi.activeVipTiers;
            if (customer_tier && customer_tier.id) {
                rank = $.grep(tiers, function(e) {
                    return e.id === customer_tier.id;
                })[0].rank;
                return rank;
            } else {
                intro_tier = $.grep(tiers, function(e) {
                    return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
                });
                if (intro_tier.length > 0) {
                    return intro_tier[0].rank;
                } else {
                    return null;
                }
            }
        },
        getTierByRank: function(rank) {
            var tiers;
            tiers = spapi.activeVipTiers;
            return $.grep(tiers, function(e) {
                return e.rank === rank;
            })[0];
        },
        setupCustomerTierStatus: function() {
            var columnLength, customer_tier_id, customer_tier_rank, data_id, next_tier, spend_required, more_purhcases, current = 2;
            customer_tier_id = SwellConfig.Tier.getCustomerTierId();
            customer_tier_rank = SwellConfig.Tier.getCustomerTierRank();
            next_tier = SwellConfig.Tier.getTierByRank(customer_tier_rank + 1);

            columnLength = $(".swell-tier-table-desktop .swell-tier-values").children().length;

            if (customer_tier_id == spapi.activeVipTiers[spapi.activeVipTiers.length - 1].id) {
                if ($(window).width() <= 768) {
                    $(".vip-table-section-holder .swell-tier-table:nth-child(" + columnLength + ") .swell-tier-current-status th:nth-child(2)").append("current status");
                    $(".vip-table-section-holder .swell-tier-table:nth-child(" + columnLength + ") th:nth-child(2)").addClass("swell-current-status");
                } else {
                    $(".swell-tier-table .swell-tier-current-status th:nth-child(" + columnLength + ")").append("current status");
                    $(".swell-tier-table th:nth-child(" + columnLength + ")").addClass("swell-current-status");
                }
                current = columnLength;
                $(".swell-campaign .swell-campaign-content[data-campaign-id='455737']").parent().remove();
                $(".swell-campaign .swell-campaign-content[data-campaign-id='489714']").parent().remove();
            } else {
                for (counter = 2; counter < columnLength; counter++) {
                    if ($(window).width() <= 768) {
                        data_id = $(".swell-tier-table-mobile:nth-child(" + counter + ") .swell-tier-names th:nth-child(2)").data("tier-id");
                    } else {
                        data_id = $(".swell-tier-table .swell-tier-names th:nth-child(" + counter + ")").data("tier-id");
                    }
                    if (data_id == customer_tier_id) {
                        if ($(window).width() <= 768) {
                            $(".swell-tier-table-mobile:nth-child(" + counter + ") .swell-tier-current-status th:nth-child(2)").append("current status");
                            $(".swell-tier-table-mobile:nth-child(" + counter + ") th:nth-child(2)").addClass("swell-current-status");    
                        } else {
                            $(".swell-tier-table-desktop .swell-tier-current-status th:nth-child(" + (counter) + ")").append("current status");
                            $(".swell-tier-table-desktop th:nth-child(" + (counter) + ")").addClass("swell-current-status");    
                        }

                        if(swellAPI.getCustomerDetails().vipTierStats) {
                            spend_required = ((next_tier.amount_spent_cents - swellAPI.getCustomerDetails().vipTierStats.amountSpentCents) / 100);
                            more_purhcases = next_tier.purchases_made - swellAPI.getCustomerDetails().vipTierStats.purchasesMade;
                        } else {
                            spend_required = spapi.activeVipTiers[1].prettyAmountSpent;
                        }
                        if(spend_required < 0) {
                            spend_required = 0;
                        }
                        if(more_purhcases < 0) {
                            more_purhcases = 0;
                        }
                        $(".swell-tier-table .swell-tier-current-status th:nth-child(" + (counter + 1) + ")").append("<span class='swell-next-status'>Spend $" + spend_required + " more and make "+ more_purhcases +" purchases  more for " + next_tier.name + "</span>");

                        if(counter==2) {
                            $(".swell-campaign .swell-campaign-content[data-campaign-id='489714']").parent().remove();
                            $(".swell-campaign .swell-campaign-content[data-campaign-id='489715']").parent().remove();
                        } else if(counter==3) {
                            $(".swell-campaign .swell-campaign-content[data-campaign-id='489714']").parent().remove();
                            $(".swell-campaign .swell-campaign-content[data-campaign-id='489715']").parent().remove();
                        } else if(counter==4) {
                            $(".swell-campaign .swell-campaign-content[data-campaign-id='455737']").parent().remove();
                            $(".swell-campaign .swell-campaign-content[data-campaign-id='489715']").parent().remove();
                        } else if(counter==5) {
                            $(".swell-campaign .swell-campaign-content[data-campaign-id='455737']").parent().remove();
                            $(".swell-campaign .swell-campaign-content[data-campaign-id='489714']").parent().remove();
                        }
                    }
                }
            }
        
            return current;
        },
        initializeDummyTier: function() {
            var k, len, tier, tiers;
            tiers = spapi.activeVipTiers;
            for (k = 0, len = tiers.length; k < len; k++) {
                tier = tiers[k];
                tier.rank += 1;
            }
            return tiers.unshift({
                id: -1,
                rank: 0,
                name: "silver",
                point_multiplier: "1x",
                free_gift: "",
                swellrequiredAmountSpent: "$0",
                swellrequiredAmountSpentCents: 0,
                swellrequiredPointsEarned: 0,
                swellrequiredPurchasesMade: 0,
                swellrequiredReferralsCompleted: 0
            });
        },
        initializeCustomTierProperties: function() {
            var tier_dummy   = (spapi.activeVipTiers[1].amount_spent_cents / 100) - 1;
            var tier_0_upper = (spapi.activeVipTiers[2].amount_spent_cents / 100) - 1;
            var tier_1_upper = (spapi.activeVipTiers[3].amount_spent_cents / 100) - 1;

            spapi.activeVipTiers[0].points = "$0 to $" + tier_dummy;
            spapi.activeVipTiers[0].points_per_dollar_spent = "1 point";
            spapi.activeVipTiers[0].free_us_shipping = "";
            spapi.activeVipTiers[0].annual_birthday = "";
            spapi.activeVipTiers[0].double_points_day = "";
            spapi.activeVipTiers[0].credits = "";
            spapi.activeVipTiers[0].exclusive_access = "";
            spapi.activeVipTiers[0].invitation = "";

            spapi.activeVipTiers[1].points = "$"+ (spapi.activeVipTiers[1].amount_spent_cents / 100) + " to $" + tier_0_upper+ " <br> and make " + spapi.activeVipTiers[1].purchases_made +" purchases";
            spapi.activeVipTiers[1].points_per_dollar_spent = "1 point";
            spapi.activeVipTiers[1].free_us_shipping = "Orders of $75+";
            spapi.activeVipTiers[1].annual_birthday = "15% off online coupon";
            spapi.activeVipTiers[1].double_points_day = "<i class='swell-icon-bunny'></i>";
            spapi.activeVipTiers[1].credits = "$25";
            spapi.activeVipTiers[1].exclusive_access = "";
            spapi.activeVipTiers[1].invitation = "";

            spapi.activeVipTiers[2].points = "$" + (spapi.activeVipTiers[2].amount_spent_cents / 100) + " to $" + tier_1_upper + " <br> and make "+ spapi.activeVipTiers[2].purchases_made +" purchases";
            spapi.activeVipTiers[2].points_per_dollar_spent = "1.5 points";
            spapi.activeVipTiers[2].free_us_shipping = "Orders of $50+";
            spapi.activeVipTiers[2].annual_birthday = "15% off online coupon";
            spapi.activeVipTiers[2].double_points_day = "<i class='swell-icon-bunny'></i>";
            spapi.activeVipTiers[2].credits = "$50";
            spapi.activeVipTiers[2].exclusive_access = "<i class='swell-icon-bunny'></i>";
            spapi.activeVipTiers[2].invitation = "";

            spapi.activeVipTiers[3].points = "$" + (spapi.activeVipTiers[3].amount_spent_cents / 100) + "+ <br>and make "+ spapi.activeVipTiers[3].purchases_made +" purchases";
            spapi.activeVipTiers[3].points_per_dollar_spent = "2 points";
            spapi.activeVipTiers[3].free_us_shipping = "All Orders";
            spapi.activeVipTiers[3].annual_birthday = "15% off online coupon";
            spapi.activeVipTiers[3].double_points_day = "<i class='swell-icon-bunny'></i>";
            spapi.activeVipTiers[3].credits = "$75";
            spapi.activeVipTiers[3].exclusive_access = "<i class='swell-icon-bunny'></i>";
            spapi.activeVipTiers[3].invitation = "<i class='swell-icon-bunny'></i>";
        },
        // referralTableOnMobile: function(current) {
        //     SwellConfig.Tier.setupCustomerTierStatus();
        //     // var columnLength = $(".swell-tier-table .swell-tier-values").children().length;
        //     // for (counter = 2; counter <= columnLength; counter++) {
        //     //     if (counter != current) {
        //     //         $(".swell-tier-table tr th:nth-child(" + counter + ")").addClass("hidden");
        //     //         $(".swell-tier-table tr td:nth-child(" + counter + ")").addClass("hidden");
        //     //     }
        //     //     else {
        //     //         $(".swell-tier-table tr th:nth-child(" + counter + ")").removeClass("hidden");
        //     //         $(".swell-tier-table tr td:nth-child(" + counter + ")").removeClass("hidden");   
        //     //     }
        //     // }
        //     // return;
        // },
        // referralTableOnDesktop: function() {
        //     SwellConfig.Tier.setupCustomerTierStatus();
        //     // var columnLength = $(".swell-tier-table .swell-tier-values").children().length;
        //     // for (counter = 2; counter <= columnLength; counter++) {
        //     //     $(".swell-tier-table tr th:nth-child(" + counter + ")").removeClass("hidden");
        //     //     $(".swell-tier-table tr td:nth-child(" + counter + ")").removeClass("hidden");
        //     // }
        //     // return;
        // },
        initializeTiers: function(containerSelector) {
            var i, j, key, properties, property, ref, ref1, tiers, current_tier = 2;
            if ($(containerSelector).length === 0) {
                return "";
            }
            tiers = spapi.activeVipTiers;
            properties = {
                header: {
                    name: {
                        className: "swell-tier-names",
                        title: ""
                    },
                    points: {
                        className: "swell-tier-values",
                        title: "benefits"
                    }
                },
                body: {
                    points_per_dollar_spent: {
                        title: "Points per online $ spent"
                    },
                    free_us_shipping: {
                        title: "Free U.S. shipping"
                    },
                    annual_birthday: {
                        title: "Annual birthday gift"
                    },
                    double_points_day: {
                        title: "Double points day"
                    },
                    credits: {
                        title: "Welcome credit (online) added to account"
                    },
                    exclusive_access: {
                        title: "Exclusive access to shop pre-sale"
                    },
                    invitation: {
                        title: "Invitation to join our elite advisory board"
                    }
                }
            };
            $(containerSelector).append("<thead></thead>");
            $(containerSelector).append("<tbody></tbody>");
            j = 0;
            ref = properties.header;
            for (key in ref) {
                property = ref[key];
                $(containerSelector).find("thead").append("<tr class=\"" + property.className + "\">\n  <th scope=\"row\">" + property.title + "</th>\n</tr>");
                tiers.forEach(function(tier) {
                    return $(containerSelector).find("thead tr:eq(" + j + ")").append("<th scope=\"col\" data-tier-id=\"" + tier.id + "\">" + tier[key] + "</th>");
                });
                j++;
            }
            i = 0;
            ref1 = properties.body;
            for (key in ref1) {
                property = ref1[key];
                $(containerSelector).find("tbody").append("<tr>\n  <td scope=\"row\">" + property.title + "</td>\n</tr>");
                tiers.forEach(function(tier) {
                    return $(containerSelector).find("tbody tr:eq(" + i + ")").append("<td data-tier-id=\"" + tier.id + "\">" + tier[key] + "</td>");
                });
                i++;
            }
            
            $(".swell-tier-table-desktop thead").prepend("<tr class='swell-tier-current-status'><th></th><th></th><th></th><th></th><th></th></tr>");
            if(spapi.authenticated) {
                current_tier = SwellConfig.Tier.setupCustomerTierStatus();
            }
            $(".swell-tier-table-desktop thead").prepend("<tr class='swell-tier-arrows'><th></th><th><i class='swell-icon-swell-left-arrow swell-icon-left-tier'><span class='path2'></span></i><i class='swell-icon-swell-right-arrow swell-icon-right-tier'><span class='path2'></span></i></th></tr>");
        }
    };

}).call(this);
